const Children = () => import("./views/Children.vue");
const ChildrenImport = () => import("./views/ChildrenImport.vue");

const route = "/children";

export default [
  {
    path: route,

    name: "children.list",
    component: Children,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/import`,
    name: "children.import",
    component: ChildrenImport,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
